import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import NipplePiercingImage from '../../Assets/Piercing Services/nipple piercing.png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function NipplePiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
          <title>Nipple Piercing UAE | 200-250 AED</title>
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Nipple Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Nipple Piercing 200-250 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={NipplePiercingImage} alt="Nipple Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Nipple Piercing</h3>

          <p>
            Enhance your confidence and personal style with our professional nipple piercing services in the UAE, available at an affordable price range of 200–250 AED. Nipple piercing is a popular and stylish body piercing that enhances the aesthetics of the nipple area, offering a bold yet elegant look that suits a variety of personal styles. Whether you prefer classic barbells or decorative rings, this piercing allows you to express your individuality while adding a subtle yet striking detail to your body. Suitable for all genders, nipple piercing is a versatile option that combines beauty, confidence, and self-expression in a modern and fashionable way.
          </p>

          <p>
            At our piercing studio, safety, hygiene, and comfort are our top priorities. Our certified professionals use sterile, single-use, high-quality equipment to perform each nipple piercing with precision and care. We strictly follow professional hygiene protocols to maintain a clean and sanitized environment, minimizing the risk of infection and ensuring a safe and smooth experience. Due to the sensitive nature of the area, our experienced specialists use advanced techniques to reduce discomfort and complete the procedure as quickly and efficiently as possible, ensuring a comfortable experience for every client.
          </p>

          <p>
            Nipple piercing is ideal for individuals who want a bold and confident style that enhances their body aesthetics. It can be worn with a variety of jewelry styles, including barbells, rings, and decorative pieces, allowing you to customize your look based on your preferences. This piercing can be a subtle personal feature or a statement of self-expression, depending on how you choose to style it. Our specialists take the time to understand your preferences and guide you in selecting the best jewelry options and placement to suit your body and comfort level.
          </p>

          <p>
            The procedure is typically completed within a short time, making it convenient even for clients with busy schedules. We provide high-quality, hypoallergenic starter jewelry that is safe for sensitive skin, helping to prevent irritation and support a smooth healing process. Our goal is to deliver a safe, stylish, and comfortable experience from start to finish.
          </p>

          <p>
            Our clean, welcoming, and professional environment ensures that every client feels relaxed and confident throughout their visit. We understand that body piercings can feel intimidating, especially for first-time clients, and our friendly and experienced staff is always available to answer your questions and provide reassurance. From consultation to completion, we focus on delivering a positive and stress-free experience tailored to your needs.
          </p>

          <p>
            Aftercare is a crucial part of maintaining your nipple piercing, and we provide detailed instructions to help you care for it properly. Our specialists will guide you on cleaning routines, recommended products, and precautions to avoid infection or irritation. Following proper aftercare is essential for healing and ensures that your piercing remains healthy and visually appealing over time.
          </p>

          <p>
            Our nipple piercing services in the UAE combine affordability with premium quality, offering transparent pricing with no hidden charges. Booking your appointment is quick and convenient, allowing you to choose a time that suits your schedule. We aim to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <p>
            Choose our trusted nipple piercing services in the UAE for a safe, hygienic, and professional experience. With skilled specialists, precise techniques, and a strong focus on customer satisfaction, we help you achieve a confident and stylish look effortlessly. Book your nipple piercing appointment today and embrace your individuality with expert care and confidence.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Nipple Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default NipplePiercing;